import script from "./Folder.vue?vue&type=script&setup=true&lang=ts"
export * from "./Folder.vue?vue&type=script&setup=true&lang=ts"

import "./Folder.vue?vue&type=style&index=0&id=647fa49e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-647fa49e"]])

export default __exports__